import styled from "styled-components";

export const GoalSelectionWrapper = styled.div`
  .semi-header {
    display: flex;
    padding: 16px 24px;
    justify-content: flex-end;
  }
`;
